export default __webpack_public_path__ + "static/media/oscar1.7b71ba53.png";